import { type TranslationIDs, useIntl } from '@capsicum/common';
import { useCallback } from 'react';
import styled from 'styled-components';

export const useOnboardingSlidesTranslations = () => {
	const { $t } = useIntl();

	return useCallback(
		(translationID: TranslationIDs) =>
			$t<JSX.Element>(translationID, {
				blue: chunks => <S.Blue>{chunks}</S.Blue>,
				br: <br />
			}),
		[$t]
	);
};

namespace S {
	export const Blue = styled.span`
		color: ${({ theme }) => theme.colors.text.brand.enabled};
	`;
}
